import React, {useState, useEffect}from 'react'
import Header from './assets/component/header/Header' 
import Nav from './assets/component/nav/Nav'
import About from './assets/component/about/About'
import Experience from './assets/component/experience/Experience'
// import Services from './assets/component/services/Services'
import Portofolio from './assets/component/portofolio/Portofolio'
// import Testimonials from './assets/component/testimonials/Testimonials'
import Contact from './assets/component/contact/Contact'
import Footer from './assets/component/footer/Footer'
import Preloader from './Preloader'
// import {  BrowserRouter as Router} from 'react-router-dom'
const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate a loading delay
    setTimeout(() => {
      setIsLoading(false);
    }, 2500); // Adjust the timeout duration as needed
  }, []);
  
  return (
    <div className="app">
    {isLoading ? (<Preloader />) : ( 
    <>
       < Header/>
       < Nav/>
       <About/>
       <Experience/>
       <Portofolio/>
       <Contact/>
       <Footer/>
    </>
    )}
  </div>
  );
}

export default App
